// extracted by css-extract-rspack-plugin
export default {"modalBodyContainer":"RY7Qp","modalSelectContainer":"ZlbRi","submitButton":"TpAbE"};